import {useKeycloak} from "@react-keycloak/web";
import {useMemo} from "react";

export const useKeycloakHeader = () => {
    const { keycloak } = useKeycloak();

    const config = useMemo(() => {
        if (keycloak?.authenticated && keycloak.token) {
            return {
                headers: {
                    'Authorization': `Bearer ${keycloak.token}`
                }
            };
        }
        return { headers: {} };
    }, [keycloak?.authenticated, keycloak?.token]);

    return config;
};

